import { memo, useEffect } from 'react';
import cn from 'classnames';
import { Element, RouterLink } from 'src/components';
import Level from 'src/components/grid/level';
import styles from '../404/styles.module.scss';
import { useNetworkState } from 'react-use';
import { Logger } from 'src/utils';

export function ContentError({ error }: { error: any }) {
    const netWork = useNetworkState();

    useEffect(() => {
        if (typeof netWork.online !== 'undefined' && netWork.online) {
            Logger.error(
                400,
                'Error',
                'message: ',
                error.message,
                'name: ',
                error.name,
                '| pathname: ',
                window.location.href
            );
            setTimeout(() => {
                window.location.reload();
            }, 100);
        }
    }, [netWork]);

    return (
        <Element className={styles['error-page']}>
            <Level className={styles['error__title']}>
                <Level.Side align="left">
                    <RouterLink
                        to="/"
                        className={styles['error__logo']}
                    ></RouterLink>
                </Level.Side>
                <Level.Side align="right">
                    <RouterLink
                        to="/"
                        className={styles['error__inst']}
                        newTab={true}
                    >
                        Tải ứng dụng Báo Mới
                    </RouterLink>
                    <RouterLink
                        to="https://www.facebook.com/Baomoi"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--fb']
                        )}
                    ></RouterLink>
                    <RouterLink
                        to="https://zalo.me/"
                        className={cn(
                            styles['error__btn'],
                            styles['error__btn--zalo']
                        )}
                    ></RouterLink>
                </Level.Side>
            </Level>
            <Element className={styles['error__content']}>
                <Element className="text-[3.6rem] tracking-[-2px] leading-[normal]">
                    Có lỗi xảy ra.{' '}
                    <Element className="text-[#538455]">
                        Vui lòng tải lại trang
                    </Element>
                </Element>
                <Element renderAs="p">
                    Để thử lại, xin hãy bắt đầu bằng cách click vào{' '}
                    <a href="/" className={styles['link']}>
                        Trang chủ
                    </a>
                </Element>
            </Element>
        </Element>
    );
}

export default memo(ContentError);
